import {Button} from "@mui/material";
import React, {useRef, useState} from "react";
import * as XLSX from "xlsx";
import {excelUpload} from "../../../../api";


export default function ExcelUpload(){

    const fileInputInfo = useRef(null);
    const [file,setFile]=useState('')

    const onUploadButton = (e) =>{
        fileInputInfo.current.click();
    }

    const inputChange = (e)=>{
        const input = e.target;
        const reader = new FileReader();
        reader.onload = function (){
            const fileData = reader.result;
            const wb = XLSX.read(fileData,{type: 'binary'});
            wb.SheetNames.forEach(function (sheetName){
                const rowObj = XLSX.utils.sheet_to_json(wb.Sheets[sheetName]);
                excelUpload(rowObj)
                    .then(res=>{
                        setFile(res.data)
                        alert("업로드 완료")
                        window.location.reload()
                    }).catch(function (err){
                    alert(JSON.stringify(err.response.data))
                })

            })
        };
        reader.readAsBinaryString(input.files[0]);
    }

    return(
        <>
            <Button
                variant="contained"
                size="large"
                sx={{marginRight:2}}
                onClick={onUploadButton}
            >
                업로드(Excel)
            </Button>
            <input
                type="file"
                id="excelFile"
                ref={fileInputInfo}
                onChange={inputChange}
                style={{display:"none"}}/>
        </>
    )
}